function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.468 4.107a.667.667 0 0 1-.023.954L18.316 16.35l12.13 11.287a.667.667 0 0 1 .022.954l-1.19 1.219a.667.667 0 0 1-.931.022l-12.26-11.408-12.28 11.429a.667.667 0 0 1-.909 0l-1.353-1.259a.667.667 0 0 1 .004-.98L13.827 16.35 1.549 5.084a.667.667 0 0 1-.003-.98l1.352-1.258a.667.667 0 0 1 .908 0l12.282 11.429L28.347 2.866a.667.667 0 0 1 .93.022l1.191 1.22Z",
  fill: "#fff"
});

var SvgXWhite = function SvgXWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgXWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/x-white.38ab49ae.svg";
export { ForwardRef as ReactComponent };